<script setup>
import { isImageAttachment } from '@/helpers/support'

/**
 * The files on a message. Pictures are what dealers send most — a scan that came out wrong,
 * a listing that looks off — so they show as thumbnails that open full size; anything else
 * is a named row.
 *
 * Interim design, no frame yet.
 */
defineProps({
  attachments: { type: Array, required: true },
})

const nameOf = (attachment) => attachment.fileName ?? attachment.name ?? 'Attachment'
</script>

<template>
  <ul class="mt-2 flex flex-col gap-y-2">
    <li v-for="attachment in attachments" :key="attachment.id ?? nameOf(attachment)">
      <a
        v-if="isImageAttachment(attachment) && attachment.url"
        :href="attachment.url"
        target="_blank"
        rel="noopener noreferrer"
        class="block w-fit overflow-hidden rounded-lg border border-gray-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-300"
      >
        <img :src="attachment.url" :alt="nameOf(attachment)" loading="lazy" class="block max-h-40 w-auto object-cover" />
      </a>

      <!-- A file with no preview: its name is the link, and its own icon says what it is. -->
      <a
        v-else
        :href="attachment.url || undefined"
        :target="attachment.url ? '_blank' : undefined"
        rel="noopener noreferrer"
        class="flex items-center gap-x-2 rounded-lg border border-gray-200 bg-white px-2.5 py-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-300"
      >
        <Icon icon="heroicons-outline:paper-clip" class="size-4 shrink-0 text-gray-400" />
        <span class="min-w-0 flex-1 truncate text-xs font-medium text-gray-700" v-text="nameOf(attachment)" />
      </a>
    </li>
  </ul>
</template>
